import { TextField } from '@fs/zion-ui'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import useDebounce from '../../hooks/useDebounce'
import useNotifications from '../../hooks/useNotifications'
import { getMemberName } from '../../services/membershipService'
import { isMrn } from '../../util/EntityUtil'

export default function DmcVerifiedMrnTextField({
  value,
  onChange,
  setIsVerifiedMember,
  label,
  placeholder,
  onBlur,
  verifyOnRender = false,
}) {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const [verifiedMemberName, setVerifiedMemberName] = useState()

  const getValidMessage = () => {
    if (isMrn(value)) {
      if (verifiedMemberName) {
        return verifiedMemberName
      }
    }
    return null
  }

  const getErrorMessage = () => {
    if (!value) {
      return null
    }
    if (!isMrn(value)) {
      return t('user.invalidMrn', 'Invalid MRN')
    }
    if (verifiedMemberName === 'Not Found') {
      return t('user.memberNotFound', 'Member not found')
    }
    return null
  }

  const getPersonAsync = async (mrn) => {
    setIsVerifiedMember(false)
    setVerifiedMemberName()
    if (!mrn || mrn.length === 0) {
      setIsVerifiedMember(true)
      setVerifiedMemberName()
    } else if (isMrn(mrn)) {
      try {
        const name = await getMemberName(mrn)
        setVerifiedMemberName(name)
        setIsVerifiedMember(name !== 'Not Found')
      } catch (err) {
        setIsVerifiedMember(false)
        setVerifiedMemberName('Not Found')
        error(`Error verifying mrn: ${err.message || ''}`, err)
      }
    }
  }

  const getPersonDebounced = useDebounce(getPersonAsync, 500)
  const onInputChange = (e) => {
    setIsVerifiedMember(false)
    setVerifiedMemberName()

    onChange(e)
    getPersonDebounced(e.target.value)
  }

  useEffect(() => {
    if (verifyOnRender) {
      getPersonDebounced(value)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <TextField
      id="DmcVerifiedMrnTextField"
      label={label}
      placeholder={placeholder}
      type="text"
      value={value}
      onChange={onInputChange}
      onBlur={onBlur}
      validMessage={getValidMessage()}
      errorMessage={getErrorMessage()}
    />
  )
}
